import React from "react";
import HeroCarousel from "../../../components/HeroCarousel/HeroCarousel";
import HeroSection from "../../../components/hero-section/HeroSection";
import PrivacyPolicy from "../../../components/footer/privacy-policy/privacyPolicy";
import PageHeader from "../../../components/page-header/PageHeader";
import bgImg from "../../../resources/images/hfi-images/Svit-Video-Production-7.webp"

const PrivacyPolicyPage = () => {
  return (
    <div>
      <HeroSection
        title={""}
        subtitle={"Privacy Policy"}
        backgroundImage={bgImg}
      />
      

      <PrivacyPolicy />
    </div>
  );
};

export default PrivacyPolicyPage;
